module.exports = __webpack_public_path__ + "5e86576c90e00f7695b2b5c4981d937e.png";